import { TradableTransaction } from "./tradable_transaction";
import { TradableWallet } from "@models/interfaces/tradable_wallet";

export abstract class AssetTransaction extends TradableTransaction {
	protected is_metal_storage_fee: boolean = false;

	public contact_id: string = "";
	public cryptocoin_symbol: string = "";
	protected purpose_text: string = "";

	protected destination_tag: string = "";
	protected dt_type: string = "";
	protected coin_network_id: string = "";

	public isExternal(): boolean {
		return this.hasTxId() && this.tx_id !== "internal";
	}

	public hasPurposeText(): boolean {
		return this.purpose_text.length > 0;
	}

	public getDestinationTag(): string {
		return this.destination_tag;
	}

	public getCoinNetworkId(): string {
		return this.coin_network_id;
	}

	public getAmountEurInklFee(): string {
		return this.amount_eur_incl_fee;
	}

	public getDtType(): string {
		return this.dt_type;
	}

	public setPurposeText(text: string): void {
		this.purpose_text = text;
	}

	public get isStorageFee(): boolean {
		return this.is_metal_storage_fee;
	}

	public getPurposeText(): string {
		return this.purpose_text;
	}

	public getType(): string {
		if (this.getRelatedWalletId() !== "" && super.getType() === "transfer") {
			return "internal_transfer";
		}

		return super.getType();
	}

	public setWallet(w: TradableWallet): void {
		this.wallet_id = w.getId();
	}

	public getAddressbookId(): string {
		return this.contact_id;
	}

	public setContactId(s: string): void {
		this.contact_id = s;
	}

	public getContactId(): string {
		return this.getAddressbookId();
	}

	public get displayRecipient(): string {
		return this.recipient;
	}

	public setAddressbookId(s: string): void {
		this.setContactId(s);
	}

	public hasContact(): boolean {
		return this.contact_id !== "";
	}
}
